const commonColumns = [
  { id: 2, key: 'manager', title: 'Manager', isSortable: false },
  { id: 3, key: 'value', title: 'Value', isSortable: true },
  { id: 4, key: 'allocation', title: 'Allocation', isSortable: true },
  { id: 5, key: 'yearToDateValue', title: 'YTD', isSortable: true },
  { id: 6, key: 'monthToDateValue', title: 'MTD', isSortable: true },
  { id: 7, key: 'attribute', title: 'Attr.', isSortable: true },
  { id: 8, key: 'mgrEst', title: 'Mgr Est.', isSortable: true }
];
const defaultColumns = [{ id: 1, key: 'rank', title: '#', isSortable: false }, ...commonColumns];

const groupColumns = [
  { id: 1, key: 'strategyRank', title: '#', isSortable: false },
  ...commonColumns
];

export default { defaultColumns, groupColumns };
